import { Check } from '@mui/icons-material';
import { twMerge } from '@sortlist-frontend/design-system';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { HubSpotDemoLink } from '_components/HubSpotDemoLink';
import { homeConfig } from '_features/home/home.config';

export const FinalCTA = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <section className="py-24 bg-secondary-950">
      <div className="container-lg px-6 text-center">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
          {t('home:sections.finalCta.title')}
        </h2>

        <p className="text-lg text-white/90 mb-8 max-w-xl mx-auto">{t('home:sections.finalCta.subtitle')}</p>
        <HubSpotDemoLink
          className={twMerge(
            'inline-flex items-center bg-primary-600 text-white',
            'font-medium text-base px-6 py-3.5 rounded-lg',
            'hover:bg-primary-700 transition-colors',
            'shadow-md hover:shadow-lg',
            'leading-none',
          )}>
          {t('home:sections.finalCta.bookDemo')}
        </HubSpotDemoLink>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-8 text-sm text-white/80">
          <div className="flex items-center gap-2">
            <Check className="text-white" style={{ fontSize: '16px' }} />
            <span>{t('home:sections.finalCta.noCreditCard')}</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="text-white" style={{ fontSize: '16px' }} />
            <span>{t('home:sections.finalCta.freeDemo')}</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="text-white" style={{ fontSize: '16px' }} />
            <span>{t('home:sections.finalCta.cancelAnytime')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
